import type { LeasingFormOptions, LeasingRvOption, RentFormOptions } from "../types/calculatorData";
import type { CalcOptionsForContactUrl, CalculatorOptionWithStatus } from "./createURLToContactSection";

function withSelectedStatus<T extends CalculatorOptionWithStatus>(
  options: T[],
  selectedValue: number | null
): T[] {
  return options.map((option) => ({
    ...option,
    Status: option.Value === selectedValue
  }));
}

/** Maps flat form state into CalcOptions shape expected by createURLToContactSection. */
export function buildCalcOptionsForContactUrl(
  rent: RentFormOptions,
  leasing: LeasingFormOptions
): CalcOptionsForContactUrl {
  return {
    LongTimeRentCalculatorValuesDTO: {
      Periods: withSelectedStatus(rent.Periods, rent.selectedPeriod),
      Ows: withSelectedStatus(rent.Ows, rent.selectedOws),
      Mileages: withSelectedStatus(rent.Mileages, rent.selectedMileage)
    },
    LeasingCalculatorValues: {
      Periods: withSelectedStatus(leasing.Periods, leasing.selectedPeriod),
      Ows: withSelectedStatus(leasing.Ows, leasing.selectedOws),
      Rvs: withSelectedStatus(leasing.Rvs as LeasingRvOption[], leasing.selectedRvs)
    }
  };
}
